<template>
	<div>
		<b-row class="print-row mt-3">
			<b-col>
				<h4 class="avoid-page-break-after">Class</h4>
			</b-col>
		</b-row>
		<b-row class="mt-3" v-for="(levelData, level) in previousLevels" :key="'details-abilities-class-level-'+level">
			<b-col v-if="levelData.Abilities.length > 0">
				<h5 class="avoid-page-break-after">{{level|ordinal}} Level</h5>
				<b-row class="print-row mt-3" v-for="(ability, abilityID) in levelData.Abilities" :key="'details-abilities-class-level-'+level+'-ability-'+abilityID">
					<b-col cols="2">
						<strong>{{ability.Name}}</strong>
					</b-col>
					<b-col cols="10" class="pre">
						{{ability.Description}}
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		previousLevels: function(){
			return this.$store.getters.previousLevels
		}
	}
}
</script>

<style scoped>

</style>